import { postV1RouteEstimate } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import connection from '~services/connectionModule';

import { DeparsedRouteEstimate, RouteEstimate } from './models';

export default function useRoute() {
  const getRouteEstimate = async (args: DeparsedRouteEstimate) => {
    try {
      const response = await postV1RouteEstimate({ body: RouteEstimate.deparse(args) });

      return RouteEstimate.parse(response.data.data);
    } catch (error) {
      connection.handleRequestError(
        error,
        t('error_messages.route.failed_to_get_estimate'),
      );
    }
  };

  return { getRouteEstimate };
}
